(function () {
  function setupSlider(el) {
    var viewport = el.querySelector('.trl-slider-viewport');
    var track = el.querySelector('[data-trl-track]');
    var template = el.querySelector('[data-trl-template]');
    if (!viewport || !track || !template) return;

    var groupWidth = template.getBoundingClientRect().width;
    if (!groupWidth) return;

    function ensureEnoughClones() {
      var minTotalWidth = window.innerWidth * 2 + groupWidth;
      var currentGroups = track.children.length;
      while (groupWidth * currentGroups < minTotalWidth && currentGroups < 14) {
        var clone = template.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-trl-template');
        track.appendChild(clone);
        currentGroups += 1;
      }
    }
    ensureEnoughClones();

    var speedSeconds = parseFloat(el.dataset.trlSpeed) || 40;
    var direction = el.dataset.trlDirection === 'right' ? -1 : 1;
    var pxPerMs = groupWidth / (speedSeconds * 1000);

    var offset = 0;
    var manualPause = false;
    var dragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var moved = 0;
    var lastTime = null;

    function wrap(value) {
      var m = value % groupWidth;
      if (m > 0) m -= groupWidth;
      return m;
    }

    function applyTransform() {
      track.style.transform = 'translate3d(' + wrap(offset) + 'px, 0, 0)';
    }

    function frame(time) {
      if (lastTime === null) lastTime = time;
      var dt = time - lastTime;
      lastTime = time;
      if (!manualPause && !dragging) {
        offset -= direction * pxPerMs * dt;
      }
      applyTransform();
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    function setPaused(state) {
      manualPause = state;
      el.classList.toggle('trl-paused', manualPause || dragging);
    }

    el.querySelectorAll('.trl-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        setPaused(true);
      });
      card.addEventListener('mouseleave', function () {
        setPaused(false);
      });
      card.addEventListener('click', function (e) {
        if (moved > 6) {
          e.preventDefault();
          return;
        }
        setPaused(!manualPause);
      });
    });

    function onPointerDown(e) {
      dragging = true;
      moved = 0;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      el.classList.add('trl-dragging');
      el.classList.add('trl-paused');
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var deltaX = e.clientX - dragStartX;
      moved = Math.abs(deltaX);
      offset = dragStartOffset + deltaX;
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('trl-dragging');
      el.classList.toggle('trl-paused', manualPause);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(ensureEnoughClones, 200);
    });
  }

  function init() {
    document.querySelectorAll('[data-trl-slider]').forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
